// extracted by mini-css-extract-plugin
export default {"ClientStatus_icon_successfull":"ClientAddStatus_ClientStatus_icon_successfull__6c03n","ClientStatus_icon_faild":"ClientAddStatus_ClientStatus_icon_faild__iHvH2"};